import type { components } from '@/api/client';
import type { DownloadLocator,DownloadSnapshot } from '@/components/downloads';

type Pin=Extract<DownloadLocator,{kind:'model_export'}>;
type Job=Pick<components['schemas']['JobOut'],'status'|'progress'|'error'>;

export function modelExportKey(target:{slug:string;name:string;ref:string},opset:number,variant=''){
  return `model-export:${target.slug}:${target.name}:${target.ref}:${opset}${variant?`:${variant}`:''}`;
}

export function modelExportSnapshot(pin:Pin,job:Job):DownloadSnapshot {
  const failed=['failed','lost','cancelled'].includes(job.status);
  const ready=job.status==='done';
  const stages:Record<string,string>={fetch:'fetching_model',export:'exporting_model',simplify:'simplifying_model',store:'storing_model',done:'finishing_export'};
  const stage=job.status==='queued'?'export_queued':stages[job.progress?.stage??'']??'preparing_model_export';
  const observed=job.progress?.updated_at??'';
  return {locator:pin,remoteState:failed?'failed':ready?'ready':job.status==='queued'?'queued':'building',attempt:0,
    // Tool percentages are coarse milestones; expose their real stage without presenting a measured total.
    progress:ready||failed?null:{stage,attempt:0,sequence:Date.parse(observed)||0,completed:0,total:null,unit:'stage',observed_at:observed},
    artifact:null,error:failed?{code:'model_export_failed',message:job.error??`Export ${job.status}. Open the export job for details.`}:null,
    canRetry:false,canCancel:false,action:ready&&pin.model&&pin.version?
      {href:`/p/${encodeURIComponent(pin.project)}/models/${encodeURIComponent(pin.model)}/${encodeURIComponent(pin.version)}?tab=files`,label:'Open model files'}:
      {href:`/jobs/${encodeURIComponent(pin.jobId)}`,label:'View export job'}};
}
